import Base64Service from "./Base64Service";

abstract class PowerBITokenService {
  static parse = (token: string): any => JSON.parse(Base64Service.decode(token.split('.')[1]));
}
export default PowerBITokenService